import { VOICE_OPTIONS } from '@/data/voice-options';
import {
    VoiceOption,
    VoiceOptionsSpecification,
} from '@/domain/voice-and-language-options';

export const filterVoicesBySpecification = (
    voiceOptionsSpecification?: VoiceOptionsSpecification,
) => {
    const allowedArray: VoiceOption[] = [];

    const voiceOptionsSpecificationArray = voiceOptionsSpecification
        ? Object.entries(voiceOptionsSpecification)
        : [];

    if (voiceOptionsSpecificationArray.length === 0) {
        return VOICE_OPTIONS;
    }

    if (voiceOptionsSpecificationArray[0][0] !== 'mvoice') {
        const mvoiceIndex = voiceOptionsSpecificationArray.findIndex(
            (spec) => spec[0] === 'mvoice',
        );

        if (mvoiceIndex !== -1) {
            const mvoiceSpec = voiceOptionsSpecificationArray[mvoiceIndex];

            voiceOptionsSpecificationArray.splice(mvoiceIndex, 1);
            voiceOptionsSpecificationArray.unshift(mvoiceSpec);
        }
    }

    for (const [provider, languageOptions] of voiceOptionsSpecificationArray) {
        if (languageOptions.languages) {
            languageOptions.languages.map((lang) => {
                for (const voice of VOICE_OPTIONS) {
                    if (
                        provider === voice.value.provider &&
                        lang === voice.value.language.match(/[^-]+/)?.[0]
                    ) {
                        allowedArray.push(voice);
                    }
                }
            });
        }
    }

    return allowedArray;
};
